module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/edmunds-groundwork-assets/node_modules/expose-loader/index.js?$!/var/lib/jenkins/workspace/edmunds-groundwork-assets/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 0
// module chunks = 36